import { createReducer, on } from '@ngrx/store';
import { setprojectDetailsInvoiceDetails, clearprojectDetailsInvoiceDetails } from './projectDetailsInvoiceDetails.action';
import { initialprojectDetailsInvoiceDetailsState } from './projectDetailsInvoiceDetails.state';

export const projectDetailsInvoiceDetailsReducer = createReducer(
  initialprojectDetailsInvoiceDetailsState,
  on(setprojectDetailsInvoiceDetails, (state, { projectDetailsInvoiceDetails }) => ({ ...state, projectDetailsInvoiceDetails : projectDetailsInvoiceDetails })),
  on(clearprojectDetailsInvoiceDetails, state => ({ ...state, projectDetailsInvoiceDetails : null }))
);
